/**
 * Normaliza la estructura de orden/exámenes/resultados antes de generar cualquier PDF de resultados.
 * Garantiza componente_id, valor y campos usados por formatos en bloques y tablas legacy.
 */

function normNombre(s: string): string {
  return String(s || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function prepararOrdenParaPdf(orden: any): any {
  if (!orden || typeof orden !== 'object') return orden;

  const examenes = (orden.examenes ?? []).map((ex: any) => {
    const componentes = ex.componentes ?? [];
    const byId = new Map<number, any>();
    const byName = new Map<string, any>();
    for (const c of componentes) {
      if (c?.id != null) byId.set(Number(c.id), c);
      const nk = normNombre(c?.nombre);
      if (nk) byName.set(nk, c);
    }

    const resultados = (ex.resultados ?? []).map((r: any) => {
      const comp =
        r.componente_id != null
          ? byId.get(Number(r.componente_id))
          : byName.get(normNombre(r.componente_nombre));
      return {
        ...r,
        componente_id: r.componente_id ?? comp?.id ?? null,
        componente_nombre: (r.componente_nombre || comp?.nombre || ex.nombre || '').trim(),
        valor: r.valor != null && String(r.valor).trim() !== '' ? String(r.valor) : r.resultado != null ? String(r.resultado) : '',
        unidad: r.unidad ?? comp?.unidad ?? '',
        valor_referencia: r.valor_referencia ?? comp?.valor_referencia ?? '',
        tipo: r.tipo ?? comp?.tipo ?? 'texto',
        clase: r.clase ?? comp?.clase ?? null,
        observaciones: r.observaciones ?? null,
        valor_referencia_min: r.valor_referencia_min ?? comp?.valor_referencia_min ?? null,
        valor_referencia_max: r.valor_referencia_max ?? comp?.valor_referencia_max ?? null,
        punto_tiempo_min: r.punto_tiempo_min ?? comp?.punto_tiempo_min ?? null,
      };
    });

    return {
      ...ex,
      id: ex.id ?? ex.examen_id,
      examen_id: ex.examen_id ?? ex.id,
      resultados,
      componentes,
    };
  });

  return { ...orden, examenes };
}
